const LayoutConfigKeyEnum = {
    LOGO: 'logo',
    BACKGROUND_MENU: 'bg_menu',
    LOGO_PARTNER: 'logo_partner'
}
export default LayoutConfigKeyEnum